import { FC } from 'react';
import { useStore } from 'hooks/useRootStore';
import { observer } from 'mobx-react-lite';
import Grid from '@material-ui/core/Grid';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useStyles } from './styles';
// import { SelectBlock } from './SelectBlock';
import { useQuery } from 'react-query';
export const Groups: FC = observer(() => {
  const {
    notificationStore: { openNotification },
    importStore: { getLdapAttributePreferences },
  } = useStore();

  const getLdapAttributePreferencesReq = useQuery(
    'getLdapAttributePreferencesReq',
    () => getLdapAttributePreferences(),
    {
      onError: () => openNotification('error', `Can't get attribute`),
    }
  );

  const infoData = getLdapAttributePreferencesReq?.data?.data;
  const peopleData = infoData?.attributes?.filter((item: any) => item.entity === 'group') || [];
  const classes = useStyles();
  return (
    <div className={classes.box}>
      <Grid container direction='row' alignItems='center'>
        <Grid item />
        <Grid item className={classes.title}>
          Source LDAP Attribute Name
        </Grid>
        <Grid item />
        <Grid item className={classes.title}>
          Destination Cloud Directory Attribute Name
        </Grid>
      </Grid>
      {peopleData?.map((item: any, index: any) => {
        // Use preference if it exists and is not empty (not empty object or empty array), otherwise use default
        const hasValidPreference =
          item.preference &&
          ((Array.isArray(item.preference) && item.preference.length > 0) ||
            (typeof item.preference === 'object' &&
              !Array.isArray(item.preference) &&
              Object.keys(item.preference).length > 0));

        const mappingData = hasValidPreference ? item.preference : item.default;

        return (
          <Grid key={item.destKey || index} container direction='row' alignItems='center'>
            <Grid item>
              {mappingData?.sourseKey ? (
                <CheckCircleIcon style={{ color: '#3ac43a' }} />
              ) : (
                <ErrorIcon color='primary' />
              )}
            </Grid>
            <Grid item>{`${mappingData?.destLabel || item.destLabel} [${mappingData?.destKey || item.destKey}]`}</Grid>
            <Grid item>
              <ArrowForwardIcon fontSize='small' />
            </Grid>
            <Grid item>
              {`${mappingData?.sourseLabel || item.sourseLabel} [${mappingData?.sourseKey || item.sourseKey}]`}
            </Grid>
          </Grid>
        );
      })}
    </div>
  );
});
